<template>
  <a-modal v-model="visible" title="价格配置" width="800px">
    <a-table
        :columns="columns"
        :data-source="recordList"
        :pagination="false"
        rowKey="id"
        v-if="recordList.length > 0">
      <span slot="type" slot-scope="text, record">
        <span v-if="text === 'semester'">
          <a-tag color="blue">学期卡</a-tag>
        </span>
        <span v-if="text === 'year'">
          <a-tag color="purple">年卡</a-tag>
        </span>
        <span v-if="text === 'month'">
          <a-tag color="green">月卡</a-tag>
        </span>
      </span>
    </a-table>
    <p v-else>无记录</p>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import bizOrgService from '@/service/bizOrg'

export default {
  data() {
    return {
      visible: false,
      recordList: [],
      bizOrgName: '',
      columns: [
        { title: "学校", dataIndex: 'bizOrgName', align: 'center', customRender: () => this.bizOrgName},
        { title: '类型', dataIndex: 'rechargeType', scopedSlots: { customRender: 'type' }, align: 'center' },
        { title: '基础价格（元）', dataIndex: 'basePrice', align: 'center' },
        { title: '优惠后价格（元）', dataIndex: 'finalPrice', align: 'center' },
        { title: '是否展示推荐', dataIndex: 'isRecommend', align: 'center', customRender: (text) => {return text? '是' : '否'}}
      ],
    };
  },
  methods: {
    showModal(bizOrg) {
      this.visible = true;
      this.bizOrgName = bizOrg.name;
      bizOrgService.queryPriceConfigById({id: bizOrg.id}).then((res) => {
        this.recordList = res.data
      })
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
